import React from 'react';
import BTA from '../../../assets/images/bta.png';
import Advantage from '../../../assets/images/advantage-travel.svg';
import GlobalTravelCollection from '../../../assets/images/global-travel-collection.svg';
import ABTA from '../../../assets/images/abta.svg';
import IATA from '../../../assets/images/iata.svg';
import InvestorsInPeople from '../../../assets/images/investors-in-people.png';
import Image from "src/components/elements/Image";

const TravelFooter = () => {

  const logos = [BTA, Advantage, GlobalTravelCollection, ABTA, IATA, InvestorsInPeople];

  return (
    <div className="flex-shrink-0 h-12 flex items-center justify-between gap-4 px-8">
      <div className="text-sm font-medium text-white/50">Version: 2025.10.15.1 © 2024 - Good Business Travel</div>
      {logos?.length > 0 && (
        <div className="flex items-center space-x-8 opacity-50">
          {logos?.map((item) => (
            <div className="h-5">
              <Image
                src={item}
                alt={"Travel Image"}
                width={"100%"}
                height={"100%"}
                effect={"blur"}
                classes={"object-contain"}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TravelFooter;